import { defineStore } from 'pinia'

export const useMainStore = defineStore('main', {
  state: () => ({
    loading: true,
  }),
  actions: {
    setLoading(value) {
      this.loading = value
    }
  }
})
